import { Component } from '@angular/core';
import { CustomerTableComponent } from "../customer-table/customer-table.component";
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { SearchAutocomplete } from '../interfaces/search-autocomplete';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { debounceTime, filter, map, Observable, of, startWith, switchMap } from 'rxjs';
import { ConnectServerService } from '../../../services/connect-server.service';
import { ApiResponse } from '../../../interfaces/api-response';
import { Connect } from '../../../classes/connect';
import { Router } from '@angular/router';
import { PermissionsService } from '../../../services/permissions.service';

@Component({
  selector: 'app-customer-container',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    CustomerTableComponent,
    MatAutocompleteModule
  ],
  templateUrl: './customer-container.component.html',
  styleUrl: './customer-container.component.scss'
})
export class CustomerContainerComponent {

  filteredSearch$!: Observable<SearchAutocomplete[]>;
  submitted: boolean = false;
  view_allsystems_domain$!: Observable<boolean>;
  searchBarForm = new FormGroup({
    searchAutocomplete: new FormControl<SearchAutocomplete | null>(null, Validators.required)
  })

  constructor(private connectServerService: ConnectServerService, private router: Router,
    private permissionService: PermissionsService
  ) { }

  ngOnInit(): void {
    this.searchText();
    this.view_allsystems_domain$ = this.permissionService.getPermissionFunction(1, 'view-allsystems-domain').pipe(
      map(result => result ? result.permission === 1 : false)
    );
  }

  enterPressed() {
    if(this.searchBarForm.invalid) {
      this.submitted = true;
    }
    else {
      this.search();
    }
  }

  search() {
    if (this.searchBarForm.valid) {

    }
  }

  displaySearchName(searchAutocomplete?: SearchAutocomplete): string {
    return searchAutocomplete ? searchAutocomplete.title! : '';
  }

  private searchText() {
    const city_field = this.searchBarForm.get('searchAutocomplete');
    if (city_field) {
      this.filteredSearch$ = city_field.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value?.title || ''),
          filter(value => value.length > 0),
          debounceTime(400),
          switchMap((value: string) =>
            value ? this.getSearch(value) : [])
        );
    }
    else {
      this.filteredSearch$ = of([]);
    }
  }

  private getSearch(val: string): Observable<SearchAutocomplete[]> {
    return this.connectServerService.getRequest<ApiResponse<{ searchAutocomplete: SearchAutocomplete[] }>>
      (Connect.urlServerLaraApi, 'system/systemsListBySearchWeCare',
        {
          type_search: 1,
          query: val
        });
  }

  goToCustomer(option: {id: number, path: string}) {
    this.router.navigate([option.path, option.id]);
  }

}
